import { api } from '@/lib/axios';
import { tenantModulesApi } from '@/lib/modules/tenant-modules.api';
import type { Tenant, TenantStats, UpdateTenantPayload } from '../types/tenant.types';

// AP-29-N4: Die Modul-Auskunft liegt in `lib/modules` — sie wird von zwei
// Features gebraucht. Hier bleibt sie erreichbar, damit kein Aufrufer sich
// ändern muss; die Quelle gibt es aber nur einmal.
export type {
  ModuleBookingStatus,
  ModuleBookingInfo,
  ModuleRequestInfo,
  ModuleCatalogEntry,
  TenantModulesResponse,
} from '@/lib/modules/tenant-modules.api';


export const tenantsApi = {
  getMe: () =>
    api.get<Tenant>('/tenants/me'),

  updateMe: (payload: UpdateTenantPayload) =>
    api.patch<Tenant>('/tenants/me', payload),

  getStats: () =>
    api.get<TenantStats>('/tenants/me/stats'),

  /**
   * Löschung des eigenen Mandanten beantragen (DSGVO).
   * Backend markiert nur vor (isActive=false + deletionRequestedAt) —
   * die Daten selbst werden nachgelagert entfernt.
   */
  deleteMe: () =>
    api.delete<{ message: string }>('/tenants/me'),

  getSubscription: () =>
    api.get('/tenants/me/subscription'),

  /** Siehe `lib/modules/tenant-modules.api.ts` — dort steht die Quelle. */
  getModules: tenantModulesApi.getModules,

  register: (payload: {
    tenantName: string;
    subdomain: string;
    email: string;
    firstName: string;
    lastName: string;
    password: string;
    defaultLocale?: string;
  }) => api.post('/tenants/register', payload),
};
